import React, {useRef} from "react";
import Button from "./Button";

export default function FileUploadButton ({handleFileUpload, className, children}) {
  const fileInput = useRef(null);

  return (
    <>
      <input
        ref={fileInput}
        onChange={handleFileUpload}
        type="file"
        style={{ display: "none" }}
      />
      <Button icon={"far fa-cloud-upload"} onClick={() => fileInput.current.click()} className={className}>{children}</Button>
    </>
  );
}